import { render, staticRenderFns } from "./TaskReportTable.vue?vue&type=template&id=12c3d1d5&scoped=true&"
import script from "./TaskReportTable.vue?vue&type=script&lang=js&"
export * from "./TaskReportTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskReportTable.vue?vue&type=style&index=0&id=12c3d1d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3d1d5",
  null
  
)

export default component.exports